/* eslint-disable no-useless-escape */
import { __CLIENT_SIDE__ } from '@constants/env';

export const useIsMobile = () => {
  if (!__CLIENT_SIDE__) return false;

  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
